import { useQuery } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import { getAnnouncementById } from '../../../api/announcements.api';
import { queryKeys } from '../../../api/queryKeys';

/**
 * One announcement, for its details page. A 404 is an answer (deleted, or a
 * stale link) rather than an error, so it is not retried.
 */
export const useAnnouncementDetail = (id: number) => {
  const query = useQuery({
    queryKey: queryKeys.admin.announcements.detail(id),
    queryFn: async () => (await getAnnouncementById(id)).data.data,
    enabled: Number.isFinite(id),
    retry: (count, error) =>
      !(isAxiosError(error) && error.response?.status === 404) && count < 2,
  });

  return {
    announcement: query.data ?? null,
    isLoading: query.isLoading,
    notFound: isAxiosError(query.error) && query.error.response?.status === 404,
  };
};
